<div (click)="onCardClick()" [ngClass]="{'sp-btn-project-disable': disabled}" class="sp-card-project">
  <!-- Why do we have two nested divs here? sp-card-project and custom-card? -->
  <div class="custom-card" [style.min-width]="minWidth">
    <div class="card-icon-wrapper" [ngClass]="{'with-image': imageUrl}">
      <app-titan-pill *ngIf="badge" [state]="'information'">
        <span children>{{ badge }}</span>
      </app-titan-pill>
      <img *ngIf="imageUrl" [src]="imageUrl" class="card-image" alt="{{ title }}">
      <app-titan-icon *ngIf="!imageUrl && iconVariant" [variant]="iconVariant" [size]="'l'" [ngClass]="iconClass"></app-titan-icon>
    </div>
    <div class="card-content">
      <h2 class="card-title">{{ title }}</h2>
      <p class="card-description" [matTooltip]="description">{{ description }}</p>
    </div>
    <div *ngIf="showButton" class="card-footer-content">
      <app-titan-button [variant]="buttonVariant">
        <span children>{{ buttonText }}</span>
      </app-titan-button>
    </div>
  </div>
</div>
